<template>
    <div id="newsWrap">
        <section class="sale-box news-page pb-5 mt-5">
            <div class="container">
                <!--<Header></Header>-->
                <NewsList></NewsList>
            </div>
        </section>
    </div>
</template>

<script>
    import Header from './components/Header'
    import NewsList from './components/NewsList'

    export default {
        name: 'App',
        components: {
            Header,
            NewsList
        }
    }
</script>

<style lang="scss">
    @import "./style";
</style>



// WEBPACK FOOTER //
// src/App.vue